<template>
	<div class="kultunautEventFeed col" :class="dataProps.class" ref="kultunautEventFeedItemRef">
		<div class="kultunautEventFeed__list grid">
			<Spinner v-show="loading" />
			<a
				v-for="event in kultunautEvents"
				:key="event.title"
				class="kultunautEventFeedItem col-12 carousel__item"
				:href="event.link"
				:title="getDictionaryItem('goto') + ' ' + event.title"
				target="blank"
			>
				<div class="grid kultunautEventFeedItem__inner">
					<div class="col-12 kultunautEventFeedItem-col">
						<h3
							class="body-text--small bold kultunautEventFeedItem-title"
						>
							{{ event.title }}
						</h3>
					</div>
					<div class="col-12_smx-6 kultunautEventFeedItem-col">
						<span class="kultunautEventFeedItem-label label--white">
							{{ getDictionaryItem("date") }}
						</span>
						<p class="kultunautEventFeedItem-text">
							{{ event.dateStartFormatted }}
						</p>
					</div>
					<div class="col-12_smx-6 kultunautEventFeedItem-col">
						<span class="kultunautEventFeedItem-label label--white">
							{{ getDictionaryItem("place") }}
						</span>
						<p class="kultunautEventFeedItem-text">
							{{ event.place }}
						</p>
					</div>
					<div class="col-12_smx-6 kultunautEventFeedItem-col">
						<span class="kultunautEventFeedItem-label label--white">
							{{ getDictionaryItem("time") }}
						</span>
						<p class="kultunautEventFeedItem-text">
							{{ event.timeFormatted }}
						</p>
					</div>
					<div class="col-12_smx-6 kultunautEventFeedItem-col">
						<span class="kultunautEventFeedItem-label label--white">
							{{ getDictionaryItem("price") }}
						</span>
						<p class="kultunautEventFeedItem-text">
							{{ event.price }}
						</p>
					</div>
				</div>
				<span class="kultunautEventFeedItem-icon" v-html="IconCalendar">
				</span>
			</a>
		</div>
		<a
			class="section__link"
			:href="dataProps.linktomore"
			v-if="dataProps.linktomore"
		>
			{{ dataProps.textmoreeventslinktext }}
			<span class="section__link-icon" v-html="IconChevron"></span>
		</a>
	</div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import axios from "axios";
import IconCalendar from "../../../views/icons/calendar.cshtml";
import IconChevron from "../../../views/icons/chevron.cshtml";
import Spinner from "../../shared/script/vue/Spinner.vue"

const apiurl = "/api/kultunaut/getfeed";
const kultunautEvents = ref([]);
const loading = ref(true);
const dataProps = ref({});

const kultunautEventFeedItemRef = ref("kultunautEventFeedItemRef");

onMounted(() => {
	dataProps.value = kultunautEventFeedItemRef.value?.parentElement?.dataset;
	fetchData();
});

const fetchData = async () => {
	let feedAmount = dataProps.value["feedamount"];

	try {
		let response = await axios.get(apiurl + "?amount=" + feedAmount);

		if (response.status == 200) {
			kultunautEvents.value = response.data;
			setTimeout(function() {
				utilities.emitter.emit("kulturnautLoaded", "loaded");
			}, 15);
		} else {
			kultunautEvents.value = [];
		}

		loading.value = false;

		return response;
	} catch (err) {
		alert(err);
		loading.value = false;
		return false;
	}
};

const getDictionaryItem = (item) => {
	let propertyName = "text" + item;
	var value = dataProps.value[propertyName];
	return value;
};
</script>
